import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchSectors, fetchSymbols, fetchUserData } from "store/asyncThunk";

import ModernHeader from "components/ModernHeader/ModernHeader";
import RouterConfig from "./components/RouterConfig";
import { ErrorBoundary } from "react-error-boundary";

import "./App.scss";

function ErrorFallback({ error, resetErrorBoundary }) {
  return (
    <div role="alert">
      <p>Something went wrong:</p>
      <pre>{error.message}</pre>
      <br />
      <pre>{error.stack}</pre>
      <button onClick={resetErrorBoundary}>Try again</button>
    </div>
  );
}

function App() {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.main.user);
  const [isLoaded, setIsLoaded] = useState(false);

  const checkIfUserLoggedIn = async () => {
    try {
      await dispatch(fetchUserData()).unwrap();
    } catch (err) {
      // not logged in, load content, if using <ProtectedRoute> it will redirect to login
      setIsLoaded(true);
    }
  };

  const fetchAppData = async () => {
    try {
      await Promise.all([
        dispatch(fetchSectors()).unwrap(),
        dispatch(fetchSymbols()).unwrap(),
      ]);

      setIsLoaded(true);
    } catch (err) {}
  };

  useEffect(() => {
    if (user) {
      setIsLoaded(false);
      fetchAppData();
    }
  }, [user?._id]);

  useEffect(() => {
    checkIfUserLoggedIn();
  }, []);

  if (!isLoaded) return <DashboardSkeleton />;

  return (
    <ErrorBoundary
      FallbackComponent={ErrorFallback}
      onReset={() => {
        // reset the state of your app so the error doesn't happen again
      }}
    >
      <div className="main-wrapper pb-10">
        {user && <ModernHeader />}
        <main className="main-content">
          <RouterConfig />
        </main>
      </div>
    </ErrorBoundary>
  );
}

const DashboardSkeleton = () => (
  <div className="dashboard-skeleton">
    <div className="skeleton-header"></div>
    <div className="skeleton-stats">
      {[...Array(4)].map((_, i) => (
        <div key={i} className="skeleton-card"></div>
      ))}
    </div>
    <div className="skeleton-content">
      {[...Array(4)].map((_, i) => (
        <div key={i} className="skeleton-panel"></div>
      ))}
    </div>
  </div>
);

export default App;
